<script setup lang='ts'>

  import { onErrorCaptured, type Ref, ref } from 'vue'
  import { KsCallout } from '@aschehoug/kloss'

  interface IErrorCapturer{
    message?:string,
  }

  const errorMessage = withDefaults(defineProps<IErrorCapturer>(), {
    message: 'Beklager, noe gikk galt. Prøv igjen!',
  })

  const error:Ref<Error | null> = ref(null)

  onErrorCaptured(err => {
    error.value = err
    console.log(err)
  })

</script>

<template>
  <div>
    <KsCallout v-if="error" variant="error">
      <p> {{ errorMessage.message }}</p>
    </KsCallout>
    <slot v-else />
  </div>
</template>
